var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoR1Express(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 659.875,
    height: 156.333,
    viewBox: "0 0 659.875 156.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2121"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 659.875,
    height: 156.333,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.155,38.232a1.614,1.614,0,0,0,.77-1.983l-6.841-18.782a1.18,1.18,0,0,1,.137-1.092,1.154,1.154,0,0,1,.969-.5h23.768a1.167,1.167,0,0,1,1.117.776l12.2,33.531a1.2,1.2,0,0,1-.12,1.044L493.532,85.112a1.2,1.2,0,0,1-1,.546h-23.4a1.156,1.156,0,0,1-1.034-.619,1.2,1.2,0,0,1,.045-1.222l11.635-18.234a1.619,1.619,0,0,0-.535-2.262,1.6,1.6,0,0,0-.822-.227l-476.8-.784a.923.923,0,0,1-.433-.094.936.936,0,0,1-.342-.284,1.028,1.028,0,0,1-.18-.406,1.043,1.043,0,0,1,.006-.445l5.8-22.711a.982.982,0,0,1,.95-.752v.028l474.989.769h.008a1.6,1.6,0,0,0,.736-.18m18.8-23H478.184a1.809,1.809,0,0,0-1.487.777,1.787,1.787,0,0,0-.213,1.665l6.841,18.783a1,1,0,0,1-.12.9.957.957,0,0,1-.8.415L7.41,36.985a1.621,1.621,0,0,0-1.559,1.222L.052,60.929A1.593,1.593,0,0,0,0,61.315v.043a1.607,1.607,0,0,0,.9,1.425,1.6,1.6,0,0,0,.711.162l476.821.8a.97.97,0,0,1,.5.133.983.983,0,0,1,.362.368.967.967,0,0,1-.037,1L467.62,83.481a1.817,1.817,0,0,0-.055,1.858,1.78,1.78,0,0,0,1.588.945h23.388l-.033.015a1.836,1.836,0,0,0,1.543-.842l21.632-33.9a1.82,1.82,0,0,0,.175-1.6L503.65,16.434a1.794,1.794,0,0,0-1.693-1.2h-.007",
    transform: "translate(0 -15.232)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M828.39,0,810.1,28.549h10.378L803.23,93.069H831.8v-.01L856.662,0Z",
    transform: "translate(-803.23)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M744.15,28.586a4.276,4.276,0,0,1,3.277,1.027,4.721,4.721,0,0,1,.121,3.716h-.006a6.449,6.449,0,0,1-6.868,5.45H723.111l2.749-10.193ZM704.888.023,680,93.14h28.594l6.436-24.089L732.634,93.14h35.585L748.036,65.479c14.017-4.007,23.4-14.569,27.9-31.454l-.007,0c3.029-11.332,2.344-19.965-2.022-25.672-4.229-5.523-11.92-8.328-22.87-8.328Z",
    transform: "translate(-679.996 -0.023)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 658.365,
    height: 12.079,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 516.424,
    height: 71.726,
    transform: "translate(0 -0.128)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAqwAAABfCAYAAAAtW5WuAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJRSURBVHhe7dbRasJAEEBR7f//c8poA1K0spLiLT0HJHF3Js/3vG3b6R87f/3G7fPR+/58dub+qnq/P++d7R7dvWNmZXaYWbtbmVmZHe+YGffef2t2vLK3Mjv+wt7K7Hhlb2V2vLJ3ezZ++r8yO47aHUd9612746hvfb8bz/ZHfWZczj4urwAAECVYAQBIE6wAAKQJVgAA0gQrAABpghUAgDTBCgBAmmAFACBNsAIAkCZYAQBIE6wAAKQJVgAA0gQrAABpghUAgDTBCgBAmmAFACBNsAIAkCZYAQBIE6wAAKQJVgAA0gQrAABpghUAgDTBCgBAmmAFACBNsAIAkCZYAQBIE6wAAKQJVgAA0gQrAABpghUAgDTBCgBAmmAFACBNsAIAkCZYAQBIE6wAAKQJVgAA0gQrAABpghUAgDTBCgBAmmAFACBNsAIAkCZYAQBIE6wAAKQJVgAA0gQrAABpghUAgDTBCgBAmmAFACBNsAIAkCZYAQBIE6wAAKQJVgAA0gQrAABpghUAgDTBCgBAmmAFACBNsAIAkCZYAQBIE6wAAKQJVgAA0gQrAABpghUAgDTBCgBAmmAFACBNsAIAkCZYAQBIE6wAAKQJVgAA0gQrAABpghUAgDTBCgBAmmAFACBNsAIAkCZYAQBIE6wAAKQJVgAA0gQrAABpghUAgDTBCgBAmmAFACBNsAIAkCZYAQBIE6wAAKQJVgAA0gQrAABpghUAgDTBCgBAmmAFACBNsAIAkCZYAQBIE6wAAKQJVgAA0gQrAABpghUAgLDT6RPGJwS6gQEN8QAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(606.443)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.432,
    height: 93.069,
    transform: "translate(0 0)",
    fill: "url(#a)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M831.44,92.855H804.979l17.246-64.52h-9.843l17-26.486h26.389L831.438,92.863Zm-25.577-.684h25.06l23.97-89.655H829.761L813.65,27.642h9.483l-17.247,64.52Z",
    transform: "translate(-197.215 -0.453)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(513.401 0.017)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98.966,
    height: 93.117,
    transform: "translate(0 0)",
    fill: "url(#a)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M767.116,92.4H734.061l-.1-.138L715.5,67.013,708.726,92.4H682.244l24.34-91.06h45.363c10.618,0,18.041,2.665,22.068,7.929,4.164,5.44,4.791,13.774,1.847,24.794C771.3,51.131,761.68,61.594,747.238,65.172l19.878,27.244ZM734.4,91.713h31.376L746.093,64.727l.5-.12c14.449-3.4,24.07-13.74,28.614-30.741,2.882-10.786,2.31-18.927-1.727-24.193-3.9-5.078-11.135-7.66-21.523-7.66H707.109l-23.98,89.7H708.2l7-26.255,19.2,26.255Zm7.173-50.965H721.8l3.667-13.591h19.593a5.534,5.534,0,0,1,4.627,1.693,5.875,5.875,0,0,1,.407,5.189,8.14,8.14,0,0,1-8.516,6.717Zm-18.883-.684h18.883a7.438,7.438,0,0,0,7.859-6.208,5.3,5.3,0,0,0-.285-4.6,4.913,4.913,0,0,0-4.089-1.425H725.984Z",
    transform: "translate(-167.146 -0.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.256,93.381l-1.22-13.553H503.018l-8.458,13.553H469.685L527.7.37h32.455l8.291,93.011ZM537.07,25.07,513.542,61.521H539.6Z",
    transform: "translate(-115.07 -0.091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.4,93.38,418.459,59.5H386.115L377.058,93.38H351.916L376.781.369H401.93l-9.073,33.884H425.2L434.268.374H459.4L434.535,93.386Z",
    transform: "translate(-86.217 -0.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.669,93.38,296.534.369h25.133L303.54,68.127h27.054l-6.749,25.256Z",
    transform: "translate(-66.557 -0.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.449,93.38,244.314.369h25.132L244.581,93.38Z",
    transform: "translate(-53.764 -0.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.332,93.38,126.659,65.1,119.105,93.38H93.963L118.828.369h46.627C176.176.369,183.627,3,187.6,8.188c4.119,5.374,4.7,13.756,1.717,24.9-4.709,17.633-14.671,28.347-29.621,31.86l-1.357.316,20.5,28.113h-31.5Zm-9.668-69.162-4.939,17.31h21.746a9.943,9.943,0,0,0,9.483-8.242c1.3-4.839.287-9.066-4.544-9.066Z",
    transform: "translate(-23.02 -0.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.627,93.379,32.753,25.621H9.078L15.827.365H88.311L81.563,25.621H57.888L39.759,93.379Z",
    transform: "translate(-2.224 -0.089)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 132.929)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 659.875,
    height: 13.59,
    transform: "translate(-0.755 -0.756)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA2oAAAASCAYAAAAqsi06AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAG3SURBVHhe7ddbbhsxDAVQO30sxF1i19vuo1+upZDGjCp7JnEeLHAOIJBgLsaaIEbA4/l8PnSnn8fn5rCo58ls1WeN/p98s5Vb9lmH2avyw2yWazXefzs3mc1y2b/5ncOL3m0yu9bJbO873nxus5xFv8ov+6zDbO877s21er1D2srN6mQ2zd+ZrfLLPmv0q7/LO7msr/pdLOtktivXRL/5blH3fn72m88dZj0/zLo9uRuz97rzNdfMclmjf/FzF7NZLmvPD7NZrlk9O+tktjeX/Zu9W4r+br590eLLlv8Ml7NVHWY9P8w+Itfq6q5ZJ7OHclmHWbl7TmZ7c9mv8ss+a/Sbuajl7xn9Z+Wy9vwwW9Xoy95zmH1qrjdxmjuz/+J9htkjuVZ7Nvprnc1aufWzYfZA7vevP73u8BQVAACA93T68f1yvsX5+nxOXy7nKc6xnwuLGgAAQDEWNQAAgGIsagAAAMVY1AAAAIqxqAEAABRjUQMAACjGogYAAFCMRQ0AAKAYixoAAEAxFjUAAIBiLGoAAADFWNQAAACKsagBAAAUY1EDAAAoxqIGAABQjEUNAACglMPhL6k4UP6hzwKXAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.037,151.691l-3.2,11.945H246.924l-.806,2.986h14.93l-3.2,11.944h-14.93l-.806,2.986h17.916l-3.2,11.944h-29.86l11.2-41.805Zm18.952,20.9-8.63-20.9h13.527l4.39,10.87,10.332-10.87h13.557l-19.649,20.993,8.451,20.813H295.678l-4.9-10.809L280.808,193.5H267.161Zm52.366-8.958-1.612,5.972H346.7a3.614,3.614,0,0,0,3.792-2.986q.806-2.986-2.18-2.986Zm-4.807,17.916-3.2,11.944H319.408l11.2-41.805h20.9q14.93,0,10.929,14.931t-18.932,14.93Zm52.635-17.916-1.613,5.972h8.959a3.615,3.615,0,0,0,3.792-2.986q.805-2.986-2.18-2.986Zm-4.808,17.916-3.2,11.944H367.236l11.2-41.805h20.9q14.931,0,10.93,14.931-3.195,11.945-13.378,14.333l9.167,12.541h-14.93Zm75.061-29.861-3.2,11.945H436.325l-.806,2.986H450.45l-3.2,11.944H432.324l-.806,2.986h17.917l-3.2,11.944H416.378l11.2-41.805Zm18.415,26.875q-14.931,0-11.288-13.557,3.554-13.318,18.484-13.318h19.41l-3.2,11.945h-19.41q-2.985,0-3.344,1.373-.448,1.613,2.538,1.613h8.959q14.93,0,11.377,13.318Q495.739,193.5,480.809,193.5H461.4l3.2-11.944H484q2.987,0,3.434-1.613.359-1.373-2.628-1.373Zm47.23,0q-14.93,0-11.287-13.557,3.554-13.318,18.484-13.318h19.41l-3.2,11.945h-19.41q-2.986,0-3.345,1.373-.447,1.613,2.538,1.613h8.958q14.931,0,11.377,13.318Q542.969,193.5,528.04,193.5H508.63l3.2-11.944h19.41q2.985,0,3.434-1.613.358-1.373-2.628-1.373Z",
    transform: "translate(-55.608 -37.163)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoR1Express);
export default __webpack_public_path__ + "static/media/logo-r1-express.729cda23ddfd786af362ae4f5bf208ce.svg";
export { ForwardRef as ReactComponent };